import { useRecoilState } from "recoil";
import { apiState, customerDetails } from "state";
import { useEffect, useMemo } from "react";
import { getCookie } from "../lib/cookies";
import { COOKIE_NAMES } from "config";
import { AuthApi, DataApi } from "../api";

export const useAuth = ({ apiAccessToken, apiUrl, brand, env }) => {
	const [api, setApi] = useRecoilState(apiState);
	const [customer, setCustomer] = useRecoilState(customerDetails);
  useEffect(() => {
    if (customer) {
      return;
    }

    const CTCookie = getCookie(brand, env, COOKIE_NAMES.CUSTOMER_TOKEN);
    if (!CTCookie) {
      return
    }

    const cookieData = JSON.parse(CTCookie);
    const customerData = cookieData?.customer || cookieData;
    setCustomer(customerData);

    const { accessToken } = customerData;
    const customerAuth = {
      id: accessToken?.customer?.id,
      accessToken: accessToken?.accessToken,
      refreshToken: accessToken?.refreshToken,
      apiAccessToken,
    };

    const authApi = AuthApi(apiUrl, apiAccessToken);
    const dataApi = DataApi(apiUrl, apiAccessToken);

    setApi({
      customerAuth,
      authApi,
      dataApi,
    });
	}, [customer]);

	return { api, customer }
}

export const withCustomerData = Component => {
  return props => {
    const customerData = useMemo(() => {
      const CTCookie = getCookie(props.brand, props.env, COOKIE_NAMES.CUSTOMER_TOKEN);

      if (!CTCookie) {
        return
      }

      const cookieData = JSON.parse(CTCookie);
      const customerData = cookieData?.customer || cookieData;

      const { accessToken } = customerData;
      return {
        id: accessToken.customer?.id,
        accessToken: accessToken.accessToken,
        refreshToken: accessToken.refreshToken,
        apiAccessToken: props.apiAccessToken,
      };
    },  [props.brand, props.env, props.apiAccessToken])

    return <Component {...props} customerData={customerData} />;
  };
};
